export default __webpack_public_path__ + "static/N0041-a80b3afb7c5aa92939c1af2cca73b247.png";